import * as React from "react";

import { makeStyles } from "@mui/styles";

import { Document } from "../../types/Document";
import { AddFileButton } from "../../components/atoms/AddFileButton";
import { Fieldset } from "../../components/molecules/Fieldset";
import { DocumentLink } from "./DocumentLink";

export type KeyDocumentsProps = {
  caseRecord: any;
  uploadFile: (
    file: File,
    name?: string,
    tags?: string[]
  ) => Promise<{ id: string; document: Document }>;
};

export const KeyDocuments: React.FC<KeyDocumentsProps> = ({ caseRecord, uploadFile }) => {
  const [uploadedDocuments, setUploadedDocuments] = React.useState<Document[]>([]);

  const addFile = React.useCallback(
    (ev) => {
      const file = ev.target.files[0];
      uploadFile(file, file.name).then((attachment) => {
        setUploadedDocuments((docs) => [...docs, attachment.document]);
      });
    },
    [uploadFile, setUploadedDocuments]
  );

  const documents = [
    ...(caseRecord.notifier.attachments || []).map(({ document }: any) => ({
      ...document,
      tags: ["proof_of_address"],
    })),
    ...caseRecord.attachments.map(({ document }: any) => document),
    ...uploadedDocuments,
  ];

  return <KeyDocumentsView documents={documents} addFile={addFile} />;
};

export type KeyDocumentsViewProps = {
  documents: Document[];
  addFile: (ev: React.ChangeEvent<HTMLInputElement>) => void;
};

export const KeyDocumentsView: React.FC<KeyDocumentsViewProps> = ({ documents, addFile }) => {
  const classes = useStyles();

  return (
    <div className={classes.relativeContainer}>
      <Fieldset title="Key documents">
        <div>
          {documents.length === 0 ? (
            <div>
              <i>No documents available</i>
            </div>
          ) : (
            documents.map((document, index) => (
              <div key={document.id} style={{ marginTop: "1rem" }}>
                <DocumentLink document={document} />
              </div>
            ))
          )}
        </div>
      </Fieldset>

      <div className={classes.addButtonContainer}>
        <AddFileButton onFileChange={addFile} />{" "}
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  relativeContainer: {
    position: "relative",
  },

  addButtonContainer: {
    position: "absolute",
    top: "-2px",
    right: "20px",
  },

  ul: {
    paddingLeft: 0,
    listStylePosition: "inside",
  },
});
